"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = devAssert;

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/graphql/jsutils/devAssert.js
// module id = HWFI
// module chunks = 0